import { NotFoundComponent } from '../not-found/not-found.component';
import { Injectable } from '@angular/core';
import { Routes } from '@angular/router';

import { StatusComponent } from '../status/status.component';
import { HistoryPageComponent } from '../history-page/history-page.component';

export class MenuItem {
  icon: string;
  title: string;
  class: string;
  path: string;
}

export const mainMenu: any[] = [
  { path: 'status', component: StatusComponent, menuItem: { title: 'Státusz',  icon: 'pe-7s-signal', class: '' } },
  { path: 'history', component: HistoryPageComponent, menuItem: { title: 'Statisztika',  icon: 'pe-7s-graph1', class: '' } },
  { path: '404_not_found', component: NotFoundComponent },
  { path: '', redirectTo: 'status' },
  { path: '**', redirectTo: '404_not_found' }
];

@Injectable()
export class RouteService {

  constructor() {}

  mainMenu(): MenuItem[] {
    return mainMenu.filter((route) => {
      return route.menuItem !== undefined;
    }).map(route => {
      return Object.assign(new MenuItem(), route.menuItem, { path: `/${route.path}` });
    }) as MenuItem[];
  }

}



// WEBPACK FOOTER //
// /builds/iws/vanenet/src/app/main/services/route.service.ts